import { createFileRoute } from "@tanstack/react-router";

import { LogoutCallbackPage } from "@/pages/LogoutCallback";
import { validateRedirectUrl } from "@/utils/validateRedirectUrl";

export const Route = createFileRoute("/_unauthenticated/logout/callback")({
  component: LogoutCallbackPage,
  validateSearch: (search: Record<string, unknown>) => {
    if (!search.returnTo || typeof search.returnTo !== "string") {
      return {
        returnTo: "/",
      };
    }

    const validatedUrl = validateRedirectUrl(search.returnTo);

    return {
      returnTo: validatedUrl,
    };
  },
});
